export enum WalletTransactionEvent {
  All = 0,
  BuyShares = 1,
  SellShares = 2,
  TopUp = 3,
  Withdraw = 4,
  Refund = 5,
  EcfInvestment = 6
}
